export function formatPaymentAmount(amount: string | number): string {
  const num = typeof amount === "string" ? parseFloat(amount.replace(/,/g, ".")) : amount;
  if (Number.isNaN(num)) return String(amount);
  return num.toLocaleString("es-ES", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}
